import { createSupabaseClient } from "../../../hooks/useSupabase";
import { MergeAuditLog } from "../../AuditLog/AuditLogList/types";
import { Customer } from "./types";

const supabaseCustomerRequest = `
id,
first_name,
last_name,
email,
mobile_phone_number,
additional_phone_number,
merge_status,
patients:patients!legal_guardian_id (
  id,
  mrn,
  first_name,
  last_name
),
familyMembers:patients!family_contact_id (
  id,
  mrn,
  first_name,
  last_name
),
customer_audit_logs!customer_audit_logs_customer_id_fkey (
  id,
  created_at,
  fields,
  role,
  customer_id,
  customer: customer_id (
    first_name,
    last_name
  ),
  center_user: center_user_id (
    first_name,
    last_name
  )
),
appointment_customer_details (
  appointment:appointment_id (
    id,
    center:center_id (
      timezone
    )
  )
)
`;

// merge_audit_logs.record_id is a polymorphic reference (customer or
// patient merges share the same table), so there's no FK for Supabase to
// embed it via a nested select on customers — fetch it separately.
const getCustomerMergeAuditLogs = async (
  supabaseClient: ReturnType<typeof createSupabaseClient>,
  id: string,
) => {
  const { data, error } = await supabaseClient
    .from("merge_audit_logs")
    .select(
      "id, created_at, merge_type, role, target_record_id, merge_count, performed_by_name, field_changes",
    )
    .eq("record_id", id)
    .eq("merge_type", "customer")
    .order("created_at", { ascending: false })
    .returns<MergeAuditLog[]>();

  if (error) throw new Error(error.message);

  return data ?? [];
};

const getCustomerData = async (id: string) => {
  const supabaseClient = createSupabaseClient();

  const [{ data, error }, mergeAuditLogs] = await Promise.all([
    supabaseClient
      .from("customers")
      .select(supabaseCustomerRequest)
      .eq("id", id)
      .limit(1)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .order("created_at" as any, {
        foreignTable: "customer_audit_logs",
        ascending: false,
      })
      .maybeSingle<Customer>(),
    getCustomerMergeAuditLogs(supabaseClient, id),
  ]);

  if (error) throw new Error(error.message);
  if (!data) return data;

  return { ...data, merge_audit_logs: mergeAuditLogs };
};

export default getCustomerData;
